import { _ as _setPrototypeOf } from './setPrototypeOf-adc775f4.js';

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

export { _inheritsLoose as _ };
